import React, { Component } from 'react';
import { Icon } from 'antd';
import { connect } from 'react-redux';

import { auth } from '../../../../services/firebase/firebase';
import { loadUserDataAction } from "../../../../actions/userStoreActions";
import { getInstagramFeed } from "../../../../services/instagram";

import icons from '../../../../components/icons/icons';

import HeadingBar from '../../../../components/Modules/HeadingBar';
import InstagramSlider from "../../../../components/Modules/InstagramSlider";

const prevArrow = (
  <button className="slick-prev">
    <Icon component={icons.prev} />
  </button>
);
const nextArrow = (
  <button className="slick-next">
    <Icon component={icons.next} />
  </button>
);

const sliderSettings = {
  prevArrow: prevArrow,
  nextArrow: nextArrow,
  dots: false,
  infinite: false,
  speed: 500,
  slidesToShow: 4,
  slidesToScroll: 4,
  centerMode: false,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: false,
        dots: false,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
      },
    },
  ],
};

class InstagramFeed extends Component {
  constructor(props){
    super(props);
    this.state = {
      instagramPosts: []
    }

    auth().onAuthStateChanged(user => {
      user && this.props.loadUserDataAction(user.uid)
        .then((userData) => {
          this.loadInstagramPosts(userData).then(result => {
            const outputObj = {instagramPosts: result};
            if (Array.isArray(result) && result.length === 0) {
              outputObj.instagramError = true;
            }
            this.setState(outputObj)
          });
        })
        .catch((err) => console.error('Error initial profile component', err));
    });
  }

  async loadInstagramPosts(userData) {
    let result = userData && await getInstagramFeed(userData.instagram);

    return result || []
  }

  render() {
    const { instagramPosts, instagramError } = this.state;
    const { instagram } = this.props;

    let content = null;
    if (instagramError && instagram && instagram.value && !instagram.touched) {
      content = (
        <p>
          Sorry, but specified Instagram account is private or your link is not valid.
        </p>
      );
    }
    if (instagramPosts && instagramPosts.length > 0) {
      content = (
        <React.Fragment>
          <HeadingBar title={`Instagram Feed`} />
          <InstagramSlider
            instagramPosts={instagramPosts}
            sliderSettings={sliderSettings}
          />
        </React.Fragment>
      )
    }

    return content;
  }
}

export default connect(null, { loadUserDataAction })(InstagramFeed);



// WEBPACK FOOTER //
// ./src/pages/MyProfile/InfoAndEventsTab/InstagramFeed/index.js